import docsCover from 'img/unlimited-docs/aside-promo/docs.png';
import presentationCover from 'img/unlimited-docs/aside-promo/presentation.png';
import spreadsheetCover from 'img/unlimited-docs/aside-promo/spreadsheet.png';
import { UnlimitedDocumentsTariffType } from 'reactApp/modules/unlimitedDocuments/unlimitedDocuments.const';

const unlimitedDocumentsAsidePromoCoverImagesConfig: { [k in UnlimitedDocumentsTariffType]: any } = {
    [UnlimitedDocumentsTariffType.document]: docsCover,
    [UnlimitedDocumentsTariffType.spreadsheet]: spreadsheetCover,
    [UnlimitedDocumentsTariffType.presentation]: presentationCover,
};

export const getUnlimitedDocumentsAsidePromoCoverImageUrl = (type: UnlimitedDocumentsTariffType) => {
    return unlimitedDocumentsAsidePromoCoverImagesConfig[type] || docsCover;
};
